// 工作台路由
export default {
    path: 'workbench',
    component: () => import('@/components/RouterView'),
    redirect: '/workbench/dashboard',
    meta: {title: '工作台'},
    children: [{
        path: 'downloadList',
        component: () => import('@/views/workbench/downloadList'),
        meta: { title: '下载任务', activePage: '/workbench/downloadList'}
    },{
        path: 'dashboard',
        component: () => import('@/views/workbench/dashboard'),
        meta: { title: 'Dashboard2.0'}
    },{
        path: 'dashboard1',
        component: () => import('@/views/workbench/dashboard1'),
        meta: { title: 'Dashboard1.0'}
    },{
        path: 'work',
        component: () => import('@/views/workbench/work/index.vue'),
        meta: { title: '我的待办', activePage: '/workbench/work'}
    }]
}